/**
 * What a photo SAYS on an office or customer screen.
 *
 * The server labels every photo from the device it is filed against
 * (`photo_label`: `2" Double Check · Watts 007M1 · SN 40613G · Tag photo`, or
 * `Job photo · Oct 26, 2026`) and gives it a human download name
 * (`download_name`: `SN-40613G Tag 2026-10-26.jpg`) — see
 * src/server/services/photoLabels.ts. This picks it, falling back to what an
 * older server sent so a screen never shows a blank tile. A stored
 * `bf-test-<uuid>-tag-0.jpg` is never shown as a label.
 */
export interface LabelledPhoto {
    photo_label?: string | null;
    photo_tag?: string | null;
    file_name?: string | null;
}

const MACHINE_NAME = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

export function photoCaption(p: LabelledPhoto): string {
    const label = (p.photo_label ?? "").trim();
    if (label) return label;
    const tag = (p.photo_tag ?? "").trim();
    if (tag) return tag.replace(/_/g, " ");
    const name = (p.file_name ?? "").trim();
    if (name && !MACHINE_NAME.test(name)) return name;
    return "Photo";
}
